
 <div class="confirm-modal" >
   <div class="box-modal">
     <div class="box-text">
       <h1 mat-dialog-title>{{ clientsComponent()?.deleteClientMessage }}</h1>
       <h1>{{ clientsComponent()?.deleteClientWarning }}</h1>
       <span>{{ message }}</span>
     </div>
     <div class="container-btn">
       <button class="btn-cancelar" (click)="onCancelar()">Cancelar</button>
       <button class="btn-eliminar" (click)="onConfirmar()">Eliminar</button>
     </div>
   </div>
 </div>


